import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { navItems } from '../data/navigation';
export function SectionPager() {
  const {
    pathname
  } = useLocation();
  const index = navItems.findIndex(item => item.path === pathname);
  if (index === -1) return null;
  const prev = navItems[index - 1];
  const next = navItems[index + 1];
  return <nav aria-label="Section navigation" className="border-t border-line bg-paper" data-id="element-72" data-mp="1y4gmx1ulweb">
      <div className="mx-auto grid max-w-7xl sm:grid-cols-2" data-id="element-73" data-mp="3t4e6j31hy5ds">
        <div className="border-b border-line sm:border-b-0 sm:border-r" data-id="element-74" data-mp="axzwhf6cmfko">
          {prev && <Link to={prev.path} className="group flex h-full flex-col px-6 py-10 transition-colors duration-150 hover:bg-paper-deep lg:px-10" data-id="element-75" data-mp="5ywrfuqdc9cp">
              <span className="flex items-center gap-2 text-sm text-slate-text" data-id="element-76" data-mp="1mc55wnpbzhne">
                <ArrowLeftIcon className="h-4 w-4 transition-transform duration-150 group-hover:-translate-x-0.5" aria-hidden="true" data-id="element-77" data-mp="1hev5ye4bfnlb" />
                Previous section
              </span>
              <span className="mt-3 font-serif text-2xl text-ink md:text-3xl" data-id="element-78" data-mp="mr6jy9eta8fl">
                <span className="text-bronze" data-id="element-79" data-mp="rqjelgbxcjsq">{prev.number}</span> {prev.label}
              </span>
            </Link>}
        </div>
        <div data-id="element-80" data-mp="wokw3wtpcb23">
          {next && <Link to={next.path} className="group flex h-full flex-col items-end px-6 py-10 text-right transition-colors duration-150 hover:bg-paper-deep lg:px-10" data-id="element-81" data-mp="wnjknr8rxmju">
              <span className="flex items-center gap-2 text-sm text-slate-text" data-id="element-82" data-mp="42036rxkvqwf">
                Next section
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-83" data-mp="8ygtnss92hco" />
              </span>
              <span className="mt-3 font-serif text-2xl text-ink md:text-3xl" data-id="element-84" data-mp="3ch1o3vybb4n7">
                <span className="text-bronze" data-id="element-85" data-mp="3cexm5jjz4fpk">{next.number}</span> {next.label}
              </span>
            </Link>}
        </div>
      </div>
    </nav>;
}